// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 774 ? "framework" : chunkId) + "-" + {"217":"ab815bd63d46656d61d8","231":"c6592fc6e2ae2d7f40d6","774":"ec953a99140ddb807a67"}[chunkId] + ".js";
};